<template>
  <form class="login" @submit.prevent="SmsOnay">
    <h4>Hesap Onay</h4>

    <div class="form-group" :class="{ 'is-invalid': hata.OnayKodu }">
      <input class="form-control" v-model="user.OnayKodu" type="numbers">
      <label class="form-label">Sms Onay Kodu</label>
      <label class="error" v-if="hata.OnayKodu">{{hata.OnayKodu}}</label>
    </div>

    <div :class="{ 'is-invalid': hata.Urun }" style="margin-bottom: 30px">

      <label class="form-label" style="font-size: 14px;">Kullanım Amacınız</label>
      <el-radio-group @change="UrunSecim" v-model="user.Urun" size="small">
        <el-radio label="2" border>Site Yöneticisi</el-radio>
        <el-radio label="1" border>Profesyonel Yönetim Şirketi</el-radio>
        <!--el-radio-button label="3">Kira Takip</el-radio-button-->
      </el-radio-group>
      <label class="error" v-if="hata.Urun">{{hata.Urun}}</label>
    </div>

    <div class="form-group" v-if="user.Urun" :class="{ 'is-invalid': hata.Adet }">
      <input class="form-control" v-model="user.Adet" type="numbers">
      <label class="form-label">{{AdetText}}</label>
      <label class="error" v-if="hata.Adet">{{hata.Adet}}</label>
    </div>
    <div class="form-group">
      <button type="submit" class="btn btn-yesil btn-block">
        Hesabı Onayla
      </button>
    </div>
    <div class="clearfix"></div>
  </form>
</template>

<script>
  export default {
    data() {
      return {
        AdetText: null,
        user: {
          OnayKodu: null,
          Email: JSON.parse(localStorage.getItem("_ai_G")).Email,
          Urun: null,
          Adet: null
        },
        hata: {
          OnayKodu: null,
          OnayKoduTekrar: null,
        },
      }
    },
    methods: {
      UrunSecim() {
        if (this.user.Urun == 1) this.AdetText = 'Portföyünüzdeki mesken sayısı';
        if (this.user.Urun == 2) this.AdetText = 'Bina/Sitenizde bulunan mesken sayısı';
        if (this.user.Urun == 3) this.AdetText = 'Kiralık mesken sayısı';
        this.hata.Adet = null;
        this.hata.Urun = null;
      },
      SmsOnay() {
        this.hata.Adet = null;
        this.hata.OnayKodu = null;
        this.hata.Urun = null;

        if (!this.user.OnayKodu) this.hata.OnayKodu = this.$t('Hata.2'); else this.hata.OnayKodu = null;
        if (!this.user.Urun) this.hata.Urun = 'Kullanım amacınızı belirtiniz'; else this.hata.Urun = null;
        if (!this.user.Adet) {
          this.hata.Adet = this.AdetText + ' giriniz';
        } else {
          this.hata.Adet = null;
          if (this.user.Adet < 8 && this.user.Urun != 1) this.hata.Adet = 'En az 8 Mesken girmelisiniz';
          if (this.user.Urun == 1 && this.user.Adet < 250) {
            this.hata.Adet = ' Şirketler için en az 250 Mesken girmelisiniz';
          }
        }
        if (!this.hata.OnayKodu && !this.hata.Urun && !this.hata.Adet) {
          $(".login").addClass("load");

          this.$store.dispatch("Login", {...this.user, path: 'giris/onay'})
            .then(response => {
              if (response.Durum == "OK") {
                this.$message(response.Mesaj);
                window.location.reload();

              } else {
                $(".login").removeClass("load");
                this.$message.error(response.Mesaj)
                this.hata = response.Hata;

              }

            })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Giris/onay.vue